import React, { useRef, useState } from "react";
import DefaultLayout from "app/layouts/DefaultLayout";
import { useNavigate } from "react-router-dom";
import Path from "app/route/Path";
import SegmentedControl from "app/components/commonUI/SegmentedControl";
import ProductGrid from "app/components/Product/ProductGrid";
import ProductGridItem from "app/components/Product/ProductGridItem";
// import MainMenuItem from "app/components/MainMenuItem";
// import CommonConfirmDialog from "app/components/CommonDialog";
// import Path from "app/route/Path";

function Recommend() {
  return (
    <DefaultLayout
      headerProps={{
        headerClassName: "md:!block",
        pageTitle: "新規登録完了",
      }}
    >
      <p>頭皮データを登録しました</p>
    </DefaultLayout>
  );
}

export default Recommend;
